import { isOfflineZettelId } from './offlineZettel'
import type { HelpZettel } from '@/types/help'

const HIDE_KEY = 'sv.talk.uaHide'
export const UA_DONE_LIST_MS = 10000

export function loadUaTalkLocalHides(): string[] {
  if (typeof sessionStorage === 'undefined') return []
  try {
    const raw = JSON.parse(sessionStorage.getItem(HIDE_KEY) || '[]') as unknown
    return Array.isArray(raw) ? raw.filter((id): id is string => typeof id === 'string') : []
  } catch {
    return []
  }
}

export function hideUaTalkZettel(id: string): string[] {
  const next = [...new Set([...loadUaTalkLocalHides(), id])]
  try {
    sessionStorage.setItem(HIDE_KEY, JSON.stringify(next))
  } catch {
    /* ignore */
  }
  return next
}

export function clearUaTalkLocalHides(): void {
  try {
    sessionStorage.removeItem(HIDE_KEY)
  } catch {
    /* ignore */
  }
}

export function isUaTalkListVisible(
  z: HelpZettel,
  hidden: ReadonlySet<string>,
  now = Date.now(),
): boolean {
  if (hidden.has(z.id)) return false
  if (isOfflineZettelId(z.id)) return true
  if (z.status === 'in_arbeit' || z.status === 'rueckfrage') return true
  if (z.status === 'erledigt' && z.done_at) {
    return now - new Date(z.done_at).getTime() < UA_DONE_LIST_MS
  }
  return false
}
